<div class="bolt-container-fluid outer-container mb-4">
  <div class="bolt-row">
    <div
      class="bolt-col-md-6"
      [ngClass]="{
        'bolt-col-xl-auto': product.displayType === 'addOn',
        'bolt-col-xl-6': product.displayType !== 'addOn'
      }"
      >
      <div class="product-name">
        <img
          class="product-image"
          src="{{ product.imageUrl }}"
          alt="{{ product.name }} icon"
          />
          <div>
            <div class="product-label-text" id="pd-{{ product.name }}">
              {{ product.name }}
            </div>
            @if (product.errorMessage) {
              <div
                class="error border border-3 rounded-pill border-danger px-3 py-1"
                >
                <bolt-icon
                  size="md"
                  name="exclamation-circle-filled"
                  color="theme-error"
                  id="errorIconFor{{ product.name }}"
                ></bolt-icon>
                <div class="error-message" id="errormessageFor{{ product.name }}">
                  <strong>{{ product.errorMessage.slice(0, -1) }} | </strong>Rating
                  tasks or errors
                </div>
              </div>
            }
            @if (product.helpText) {
              <div
                class="product-helper-text"
                id="pd-{{ product.helpText }}-helper-text"
                >
                {{ product.helpText }}
              </div>
            }
          </div>
        </div>
      </div>

      @if (product.displayType === 'selected') {
        @if (
          product.installmentPrice || product.totalPrice) {
          <div class="bolt-col-md-3 bolt-col-xl-3">
            <div class="bolt-row">
              <div
                class="bolt-col-sm-12 product-payment-plan"
                id="pd-{{ product.name }}-payment-plan-button"
                >
                @if (!awaitingProtectorVersionChoice) {
                  <button
                    class="pill-button ml-auto"
                    (click)="editPaymentPlan(product)"
                    >
                    {{
                    getPaymentPlanDisplayName(
                    product.paymentPlan || 'Recurring EFT'
                    )
                    }}
                    <img
                      src="/assets/images/icons/pencil_edit_pale_gray.svg"
                      alt="Edit Pencil"
                      id="edit-pencil-icon-{{product.name}}"
                      />
                    </button>
                  }
                </div>
              </div>
            </div>
            <div class="bolt-col-md-3 bolt-col-xl-3">
              <div class="bolt-row">
                <div
                  class="bolt-col-sm-12 premium-overview-total"
                  id="pd-{{ product.name }}-total"
                  >
                  @if (product.totalPrice) {
                    <p
                      class="total-price"
                      id="pd-{{ product.name }}-total-price"
                      >
                      {{ product.totalPrice }}
                    </p>
                  }
                  @if (product.termLength) {
                    <p
                      class="total-term-length"
                      id="pd-{{ product.name }}-total-term-length"
                      >
                      {{ product.termLength }}
                    </p>
                  }
                </div>
                <div
                  class="bolt-col-sm-12 premium-overview-installment"
                  id="pd-{{ product.name }}-installment"
                  >
                  @if (product.installmentPrice) {
                    <p
                      class="installment-price"
                      id="pd-{{ product.name }}-installment-price"
                      >
                      {{ product.installmentPrice }}
                    </p>
                  }
                  @if (product.installmentFrequency) {
                    <p
                      class="installment-frequency"
                      id="pd-{{ product.name }}-installment-frequency"
                      >
                      {{ product.installmentFrequency }}
                    </p>
                  }
                </div>
              </div>
            </div>
          } @else {
            @if (product.errorMessage) {
              <div
                class="bolt-col-md-6 bolt-col-xl-6 error review-rating-btn"
                >
                <bolt-button
                  color="medium-blue"
                  type="outline"
                  class="button-float"
                  size="md"
                  (click)="scrollToTasks()"
                  >Review rating tasks</bolt-button
                  >
                </div>
              }
              @if (product.warningMessage) {
                <div
                  class="bolt-col-md-6 bolt-col-xl-6 error"
                  >
                  <bolt-icon
                    size="md"
                    name="exclamation-triangle-filled"
                    color="theme-warning"
                    id="warningIconFor{{ product.name }}"
                  ></bolt-icon>
                  <div class="error-message" id="warningMessageFor{{ product.name }}">
                    {{ product.warningMessage }}
                  </div>
                </div>
              }
              @if (product.message) {
                <div class="bolt-col-md-6 bolt-col-xl-6 error">
                  <div class="error-message" id="messageFor{{ product.name }}">
                    {{ product.message }}
                  </div>
                </div>
              }
              @if (
                !product.errorMessage && !product.warningMessage && !product.message
                ) {
                <div
                  class="bolt-col-md-6 bolt-col-xl-6 loading"
                  >
                  <nwx-passive-spinner
                    class="flat"
                    label="Loading"
                  ></nwx-passive-spinner>
                </div>
              }
            }
          }

          @if (product.displayType === 'addOn') {
            <div class="bolt-col upsell-content">
              <bolt-button
                type="outline"
                size="sm"
                [attr.disabled]="product.disabled ? true : null"
                (click)="addUpsell.next(product?.type)"
                id="pdc-add-{{ product.name }}"
                >{{ product.name }}</bolt-button
                >
              </div>
            }
          </div>
        </div>
